import { render } from "./MainSponsor.vue?vue&type=template&id=1a2a54ca&scoped=true"
const script = {}

import "./MainSponsor.vue?vue&type=style&index=0&id=1a2a54ca&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vizbi-frontend-test/vizbi-frontend-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a2a54ca"]])

export default __exports__